import React from 'react';
import { Auth0Provider } from "@auth0/auth0-react";
import { auth0Config } from "../../auth0Config";

/**
 * Authentication Provider Wrapper
 * Now using Auth0 exclusively
 */
const AuthProvider = ({ children }) => {
  return (
    <Auth0Provider
      domain={auth0Config.domain}
      clientId={auth0Config.clientId}
      authorizationParams={auth0Config.authorizationParams}
      cacheLocation={auth0Config.cacheLocation}
      useRefreshTokens={auth0Config.useRefreshTokens}
      useRefreshTokensFallback={auth0Config.useRefreshTokensFallback}
      onRedirectCallback={(appState, user) => {
        // Navigate to the page the user was trying to access before login
        window.history.replaceState(
          {},
          document.title,
          appState?.returnTo || window.location.pathname
        );
      }}
    >
      {children}
    </Auth0Provider>
  );
};

export default AuthProvider;